<form>
  <mat-dialog-content class="!grid">
    <p class="dialog-title">Aplazar</p>
    <hr class="dialog-divider" />
    <p class="dialog-subtitle">
      SELECCIONE LA FECHA DEL ACUERDO AL QUE DESEA APLAZAR EL TEMA
    </p>

    <mat-form-field class="!grow">
      <mat-label>Seleccionar</mat-label>
      <mat-select name="fecha" [formControl]="fecha">
        @for (item of fechasAcuerdo; track item) {
        <mat-option
          [value]="item"
          [disabled]="data.acuerdoActual == item.idFE"
          >{{ item.fechaAcuerdo | date : "dd-MM-yyyy" : "UTC" }}</mat-option
        >
        }
      </mat-select>
      @if(fecha.hasError('required')&&fecha.touched) {
      <mat-error>Campo obligatorio</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end">
    <button
      class="uppercase-button"
      mat-raised-button
      [mat-dialog-close]="false">
      CANCELAR
    </button>
    <button
      [mat-dialog-close]="false"
      mat-flat-button
      [color]="'primary'"
      [disabled]="fecha.invalid"
      (click)="save()">
      ACEPTAR
    </button>
  </mat-dialog-actions>
</form>
